/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.body = document.body;
    this.container = document.querySelector('.searchform');
    this.input = document.getElementById('header-search-input');
    this.predictiveSearchResults = document.querySelector('.thb-predictive-search');
    this.predictiveSearchFocus = document.querySelector('.thb-predictive-search-focus');

    this.predictiveSearchResults.style.display = 'none';
    this.predictiveSearchFocus.style.display = 'none';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.input.addEventListener('focus', () => {
      this.onFocus();
      this.body.classList.add('open-search');
    });

    document.addEventListener('click', (event) => {
      if (!this.container.contains(event.target) && !this.predictiveSearchResults.contains(event.target) && !this.predictiveSearchFocus.contains(event.target)) {
        this.close();
      }
    });

    this.input.addEventListener('click', () => {
      if (!this.getQuery().length) {
        this.predictiveSearchFocus.style.display = 'block';
        this.predictiveSearchResults.style.display = 'none';
      }
    });
       const closeBtn = document.querySelector('.side-panel-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        this.close();
      });
    }

    this.container.addEventListener('submit', this.onFormSubmit.bind(this));
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }
  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchFocus.style.display = 'block';
      this.predictiveSearchResults.style.display = 'none';
      return;
    }

    this.predictiveSearchFocus.style.display = 'none';
    this.predictiveSearchResults.style.display = 'block';
    this.getSearchResults(searchTerm);
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchFocus.style.display = 'block';
    } else {

      this.getSearchResults(searchTerm);
    }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
        .then((response) => {
          this.predictiveSearchResults.classList.remove('loading');
          if (!response.ok) {
            throw new Error(response.status);
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');

          if (!resultsMarkup || !resultsMarkup.innerHTML.trim().length) {
            this.renderNoResults();
          } else {
            this.renderSearchResults(resultsMarkup.innerHTML);
          }
        })
        .catch((error) => {
          console.error(error);
          this.renderNoResults();
        });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    const submitButton = document.querySelector('#search-results-submit');
    const thbSearchButton = document.querySelector('.thb-search-submit');
    if (submitButton) {
      submitButton.addEventListener('click', () => {
        console.log('âs')
        thbSearchButton.click();
      });
    }
  }

  renderNoResults() {
    this.predictiveSearchResults.innerHTML = `<p class="no-results">Không có kết quả nào được tìm thấy</p>`;
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.predictiveSearchFocus.style.display = 'none';
    this.body.classList.remove('open-search');
  }
}

window.addEventListener('load', () => {
  new PredictiveSearch();
});

function debounce(func, wait) {
  let timeout;
  return function(...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}
